<div id="addDoc">
  <div class="row page-header">
    <div class="title-header d-flex align-items-center">
      <div class="add-file"></div>
      {{'Add Additional Document' | translate}}
    </div>
  </div>
  <form [formGroup]="addFileForm">
    <div class="row content">
      <div class="form-group col-md-5">
        <label>{{'Ticket number' | translate}}</label>
        <div class="text-value">{{ documentDetail?.id}}</div>
      </div>
      <div class="form-group col-md-7">
        <label>{{'Date & Time' | translate}}</label>
        <div class="text-value">{{ documentDetail?.actual_date | date: 'dd/MM/yy HH:mm' }}</div>
      </div>
      <div class="form-group col-md-12">
        <label>{{'Customer / Supplier' | translate}}</label>
        <div class="text-value">{{ documentDetail?.company_other?.name }}</div>
      </div>
      <div class="form-group col-md-5">
        <label>{{'Trucking Company' | translate}}</label>
        <div class="text-value">{{ documentDetail?.delivered_company?.name }}</div>
      </div>
      <div class="form-group col-md-7">
        <label>{{'Driver' | translate}}</label>
        <div class="text-value">{{ documentDetail?.driven_name ?? documentDetail?.entry?.driven_name ? documentDetail?.driven_name : documentDetail?.delivered?.name }}</div>
      </div>
      <div class="form-group col-md-5">
        <label>{{'Vehicle #' | translate}}</label>
        <div class="text-value">{{ documentDetail?.vehicle_no }}</div>
      </div>
      <div class="form-group col-md-7">
        <label>{{'Product Name' | translate}}</label>
        <div class="text-value">{{ documentDetail?.product_no }}</div>
      </div>
      <div class="form-group col-md-5">
        <label>{{'Cargo #' | translate}}</label>
        <div class="text-value">{{ documentDetail?.tank_no }}</div>
      </div>

      <div class="form-group col-md-7">
        <label>{{'Sale Order / D.O. #' | translate}}</label>
        <div class="text-value">
          {{ documentDetail?.order_no }}
        </div>
      </div>

      <div class="form-group col-md-12">
        <label [class.required]="true">{{'Add additional document' | translate}}</label>
        <app-upload-file
          [drop]="true"
          [classDrop]="'small'"
          fileAccept=".pdf, .doc, .docx, image/svg, image/jpg, image/jpeg, image/png"
          formControlName="file"
        >
        </app-upload-file>
      </div>
      <div class="form-group col-md-12">
        <label [class.required]="true">{{'Reason for Additional Document' | translate}}</label>
        <textarea
          formControlName="reason"
          class="form-control"
          rows="3"
        ></textarea>
      </div>
      <div class="col-md-12">
        <div class="btn-group text-right">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="onCancel()"
          >{{'Cancel' | translate}}</button>
          <button
            type="button"
            class="btn btn-primary btn-save"
            (click)="onSave()"
            [disabled]="addFileForm.invalid"
          >
            <span *ngIf="!saving">{{'Save' | translate}}</span>
            <div
              *ngIf="saving"
              class="spinner-border"
              role="status"
            ></div>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
